import type { MenuItem } from './types';

type GovernanceNavigationVisibility = {
  isLoading: boolean;
  isVisible: boolean;
};

const GOVERNANCE_PATH = '/governance';
const REPORT_ANALYSIS_PATH = '/report/analysis';
const BUILT_IN_CHECKS_PATH = '/governance/built-in-checks';

/** Select the navigation structure that matches the organisation's Governance setting. */
export function getNavigationForGovernance(
  navigation: MenuItem[],
  governanceVisibility: GovernanceNavigationVisibility,
): MenuItem[] {
  if (governanceVisibility.isLoading) {
    return navigation
      .filter((item) => item.path !== REPORT_ANALYSIS_PATH)
      .map((item) => {
        if (item.path !== GOVERNANCE_PATH) {
          return item;
        }

        return {
          ...item,
          children: item.children?.filter(
            (child) => child.path === BUILT_IN_CHECKS_PATH,
          ),
        };
      });
  }

  return navigation.filter((item) =>
    governanceVisibility.isVisible
      ? item.path !== REPORT_ANALYSIS_PATH
      : item.path !== GOVERNANCE_PATH,
  );
}
